import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductRoutingModule } from './product-routing.module';
import { ProductListComponent } from './product-list/product-list.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductCompareComponent } from './product-compare/product-compare.component';
import { ProductRatingComponent } from './product-rating/product-rating.component';
// import { CustomerQuestionComponent } from './customer-question/customer-question.component';
import { ProductSimilarVehicleComponent } from './product-similar-vehicle/product-similar-vehicle.component';
import { NgWizardModule, NgWizardConfig, THEME } from 'ng-wizard';
import { EmiCalculatorComponent } from './emi-calculator/emi-calculator.component';
import { CustomerRatingComponent } from './customer-rating/customer-rating.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
// import { ProductFeaturesComponent } from './product-features/product-features.component';
import { VehicleSpecificationComponent } from './vehicle-specification/vehicle-specification.component';
// import { HighlightsComponent } from './highlights/highlights.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { BookingComponent } from './BOOKING-PAGE/booking/booking.component';
import { BookTestDriveComponent } from './book-test-drive/book-test-drive.component';
import { DateAgoPipe } from '../../app/shared/date-ago.pipe';
import { DatePipe } from '@angular/common';
import { ProductLeadComponent } from '../product-lead/product-lead.component';

const ngWizardConfig: NgWizardConfig = {
  theme: THEME.default
};

import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgxStarsModule } from 'ngx-stars';
import { NgxSkeletonModule } from 'ngx-skeleton';
import { FinanceBookingComponent } from './BOOKING-PAGE/finance-booking/finance-booking.component';
import { GeneralBookingComponent } from './BOOKING-PAGE/general-booking/general-booking.component';
import { OrderConfirmationComponent } from './BOOKING-PAGE/order-confirmation/order-confirmation.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { SafePipeModule } from 'safe-pipe';
import { BookingAmcListComponent } from './booking-amc-list/booking-amc-list.component';
import { ReadMoreComponent } from './read-more/read-more.component';
import { FinanceProductLeadComponent } from './finance-product-lead/finance-product-lead.component';
import { ExtendedVasComponent } from './extended-vas/extended-vas.component';

@NgModule({
  declarations: [
    // ProductListComponent,
    ProductDetailComponent,
    ProductCompareComponent,
    ProductRatingComponent,
    // CustomerQuestionComponent,
    ProductSimilarVehicleComponent,
    EmiCalculatorComponent,
    CustomerRatingComponent,
    // ProductFeaturesComponent,
    VehicleSpecificationComponent,
    // HighlightsComponent,
    BookingComponent,
    BookTestDriveComponent,DateAgoPipe,
    FinanceBookingComponent,
    GeneralBookingComponent,
    OrderConfirmationComponent,
    ProductLeadComponent,
    BookingAmcListComponent,
    ReadMoreComponent,
    FinanceProductLeadComponent,
    ExtendedVasComponent
  ],
  imports: [
    CommonModule,NgxSpinnerModule,SafePipeModule,
    ProductRoutingModule, SharedModule,FormsModule,ReactiveFormsModule,NgbModule,HighchartsChartModule,NgxSkeletonModule,
    NgCircleProgressModule.forRoot({
      radius: 60,
      space: -10,
      toFixed: 1,
      outerStrokeGradient: false,
      outerStrokeWidth: 15,
      outerStrokeColor: "#388E3C",
      innerStrokeColor: "#e7e8ea",
      innerStrokeWidth: 13,
      animateTitle: false,
      animationDuration: 1000,
      showSubtitle: false,
      showUnits: false,
      showBackground: false,
      clockwise: false,
      startFromZero: false,
      lazy: true,
      responsive: true,
      subtitleColor: "#27292F",
      subtitleFontSize: '20',
      "titleFontSize": "44",
    }),
    NgWizardModule.forRoot(ngWizardConfig),
    SlickCarouselModule,
    NgxStarsModule,
    NgxSliderModule,
  ],
  providers: [DatePipe]
})
export class ProductModule { }
